import { render, staticRenderFns } from "./formAssign.vue?vue&type=template&id=7aba3a51"
import script from "./formAssign.vue?vue&type=script&lang=js"
export * from "./formAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports